import { put, call, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
// import ApiService from '../Services/ApiService';
// import AppActions from '../Stores/App/Actions';
import PickingCriteriaProcessActions, {
  PickingCriteriaProcessTypes
} from '../Stores/PickingCriteriaProcess/Actions';

// const getAppStore = state => state.app;

export function* pickingCriteriaProcessFetchPickingCriteriaProcess() {
  try {
    yield put(
      PickingCriteriaProcessActions.pickingCriteriaProcessFetchPickingCriteriaProcessLoading(true)
    );

    const result = [
      { proc_type: 'PICKING_CRITERIA_LIST_01', icon: 'fa fa-cubes' },
      { proc_type: 'PICKING_CRITERIA_EXCEL_01', icon: 'fa fa-file-excel-o' }
    ];
    yield put(
      PickingCriteriaProcessActions.pickingCriteriaProcessFetchPickingCriteriaProcessSuccess(result)
    );

    /*
    const app = yield select(getAppStore);
    const getData = {};

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `site/indexItemFlow/${app.curSiteFlowId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );
    
    if (result.isSuccess === true) {
      yield put(PickingCriteriaProcessActions.pickingCriteriaProcessFetchPickingCriteriaProcessSuccess(result.data));
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
    */
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(
      PickingCriteriaProcessActions.pickingCriteriaProcessFetchPickingCriteriaProcessLoading(false)
    );
  }
}

export const saga = [
  takeLatest(
    PickingCriteriaProcessTypes.PICKING_CRITERIA_PROCESS_FETCH_PICKING_CRITERIA_PROCESS,
    pickingCriteriaProcessFetchPickingCriteriaProcess
  )
];
